module.exports = __webpack_public_path__ + "assets/img/2007.c3cb5d91.png";